import {cn} from '@ds/helpers';

type InvoiceDataRowProps = {
  title: React.ReactNode;
  value: React.ReactNode;
  tone?: 'default' | 'success' | 'error';
  highlighted?: boolean;
};

const InvoiceDataRow: React.FC<InvoiceDataRowProps> = ({
  title,
  value,
  tone = 'default',
  highlighted = false
}) => {
  return (
    <div
      className={cn(
        'flex min-h-11 items-center justify-between gap-3 px-2.5 py-2 text-body-sm',
        highlighted && 'rounded-sm bg-orange-pale'
      )}
    >
      <span
        className={cn(
          'text-gray-07',
          tone === 'success' && 'text-success',
          tone === 'error' && 'text-destructive!'
        )}
      >
        {title}
      </span>
      <span
        className={cn(
          'shrink-0 text-body-sm-emphasis text-gray-09',
          tone === 'success' && 'text-success',
          tone === 'error' && 'text-destructive!'
        )}
      >
        {value}
      </span>
    </div>
  );
};

export default InvoiceDataRow;
